import * as React from "react";
const SvgAgentProcessIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 40 40", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 20, r: 20, fill: "#c7adff", style: {
  fill: "#c7adff",
  fill: "color(display-p3 .7818 .6792 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#ebdeff", d: "M8.939 11.85a4 4 0 0 1 2.012-1.931l7.46-3.23a4 4 0 0 1 3.179 0l7.46 3.23a4 4 0 0 1 2.011 1.93l3.098 6.41a4 4 0 0 1 0 3.481l-3.098 6.41a4 4 0 0 1-2.012 1.931l-7.46 3.23a4 4 0 0 1-3.179 0l-7.46-3.23a4 4 0 0 1-2.011-1.93L5.84 21.74a4 4 0 0 1 0-3.481z", style: {
  fill: "#ebdeff",
  fill: "color(display-p3 .9235 .8708 1)",
  fillOpacity: 1
} }));
export default SvgAgentProcessIcon;
